const getElementById = require('../../../_common/common_functions').getElementById;
const isVisible      = require('../../../_common/common_functions').isVisible;
const State          = require('../../../_common/storage').State;
const Url            = require('../../../_common/url');
const { triggerSessionChange } = require('../../hooks/events');
const isEmptyObject  = require('../../../_common/utility').isEmptyObject;

/*
 * Handles trading page default values
 *
 * Priorities:
 * 1. Client's input: on each change to form, it will reflect to both query string & session storage
 * 2. Query string parameters: will change session storage values
 * 3. Session storage values: if none of the above, it will be the source
 *
 */

const Defaults = (() => {
    let params       = {};
    const PARAM_NAMES = {
        AMOUNT         : 'amount',
        AMOUNT_TYPE    : 'amount_type',
        BARRIER        : 'barrier',
        BARRIER_HIGH   : 'barrier_high',
        BARRIER_LOW    : 'barrier_low',
        CURRENCY       : 'currency',
        DURATION       : 'duration',
        DURATION_AMOUNT: 'duration_amount',
        DURATION_UNITS : 'duration_units',
        DURATION_VALUE : 'duration_value',
        END_DATE       : 'end_date',
        EXPIRY_DATE    : 'expiry_date',
        EXPIRY_TIME    : 'expiry_time',
        EXPIRY_TYPE    : 'expiry_type',
        FORM_NAME      : 'formname',
        IS_EQUAL       : 'is_equal',
        MARKET         : 'market',
        MULTIPLIER     : 'multiplier',
        PREDICTION     : 'prediction',
        SELECTED_TICK  : 'selected_tick',
        TRADE_TYPE     : 'trade_type',
        UNDERLYING     : 'underlying',
    };
    const getDefault = (key) => {
        let p_value = params[key] || Url.param(key);
        
        // Handle symbol parameter conversion for underlying
        if (key === PARAM_NAMES.UNDERLYING && !p_value) {
            const symbol_value = params.symbol || Url.param('symbol');
            if (symbol_value) {
                p_value = symbol_value;
                // Set the underlying parameter and remove symbol parameter
                setDefault(PARAM_NAMES.UNDERLYING, symbol_value);
                removeDefault('symbol');
            }
        }
        
        // Handle trade_type parameter as alias for formname (trade_type takes precedence)
        if (key === PARAM_NAMES.FORM_NAME && !p_value) {
            const trade_type_value = params.trade_type || Url.param('trade_type');
            if (trade_type_value) {
                p_value = trade_type_value;
            }
        }
        
        const s_value = sessionStorage.getItem(key);
        if (p_value && (!s_value || p_value !== s_value)) {
            sessionStorage.setItem(key, p_value);
        }
        if (!p_value && s_value) {
            setDefault(key, s_value);
        }
        return p_value || s_value;
    };

    const setDefault = (key, value = '') => {
        if (!key) return;
        if (isEmptyObject(params)) params = Url.paramsHash();
        if (params[key] !== value) {
            params[key] = value;
            // to increase speed, do not set values when form is still loading
            if (!isVisible(getElementById('trading_init_progress'))) {
                sessionStorage.setItem(key, value);
                updateURL();
            }
        }
    };

    const removeDefault = (...keys) => {
        if (isEmptyObject(params)) params = Url.paramsHash();
        let is_updated = false;
        keys.forEach((key) => {
            if (key in params) {
                sessionStorage.removeItem(key);
                delete params[key];
                is_updated = true;
            }
        });
        if (is_updated) {
            triggerSessionChange();
            updateURL();
        }
    };

    const updateAll = () => {
        Object.keys(params).forEach((key) => {
            sessionStorage.setItem(key, params[key]);
        });
        updateURL();
    };

    const updateURL = () => {
        if (!State.get('is_trading')) return;
        const url_params = { ...params };
        
        // Use trade_type instead of formname in URLs for cleaner appearance
        if (url_params[PARAM_NAMES.FORM_NAME]) {
            url_params[PARAM_NAMES.TRADE_TYPE] = url_params[PARAM_NAMES.FORM_NAME];
            delete url_params[PARAM_NAMES.FORM_NAME];
        }
        
        Url.updateParamsWithoutReload(url_params, false);
    };

    return {
        get   : getDefault,
        set   : setDefault,
        update: updateAll,
        remove: removeDefault,
        clear : () => { params = {}; },
        PARAM_NAMES,
    };
})();

module.exports = Defaults;
